import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { CustomerStatsClient, CustomerStatsResponse } from 'requests/nswag/atlas/AtlasClient';

async function getAllCustomerStats() {
  const client = new CustomerStatsClient();
  return client.getCustomerStats();
}

export function useFetchCustomerStats(): UseQueryResult<CustomerStatsResponse[]> {
  return useQuery({ queryKey: ['CUSTOMERSTATS'], queryFn: getAllCustomerStats });
}
